import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=455f82f4"
import script from "./MenuList.vue?vue&type=script&lang=ts"
export * from "./MenuList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports